import {BaseError} from "@/domain/errors/base-error";

export class PermissionError extends BaseError {
    constructor (errorCode: number, message: string) {
        super(errorCode, message);
        this.name = 'PermissionError'
    }
}
